// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

Macy.init({
  container: '#macy-container',
    trueOrder: true,
    waitForImages: false,
    margin: 24,
    columns: 4,
    breakAt: {
        1200: 4,
        940: 3,
        520: 2,
        400: 2
    }
});

$('a.gallery').featherlightGallery({
    previousIcon: '<',
    nextIcon: '>',
    galleryFadeIn: 300,
    openSpeed: 500
});